import { useEventBus } from '@vueuse/core'
import { ref } from 'vue'

export const useLockedRecords = () => {
    const lockedIds = ref<string[]>([])
    const recordErrors = ref<Record<string, string>>({})
    const lockBus = useEventBus('ct-record-locked')
    const unlockBus = useEventBus('ct-record-unlocked')
    const errorBus = useEventBus('ct-record-error')
    const isRecordLocked = (id?: string) => id ? lockedIds.value.includes(id) : false
    const getRecordError = (id?: string) => id ? recordErrors.value[id] : ''

    const watchLockedRecords = () => {
        lockBus.on(id => lockedIds.value.push(`${id}`))
        unlockBus.on(id => {
            lockedIds.value = lockedIds.value.filter(lId => lId !== id)
        })
        errorBus.on(opts => {
            const { recordId, error } = (opts || {}) as Record<string, string>
            recordErrors.value[recordId || ''] = error
        })
    }

    const lockRecord = (recordId?: string) => {
        if (recordId) {
            lockBus.emit(recordId)
            errorBus.emit({ recordId , error: '' })
        }
    }

    const unlockRecord = (recordId?: string) => {
        if (recordId) {
            unlockBus.emit(recordId)
        }
    }

    const handleLockedRecordError = (recordId?: string, error?: string) => {
        if (recordId) {
            unlockBus.emit(recordId)
            errorBus.emit({ recordId, error })
        }
    }

    return {
        isRecordLocked,
        lockRecord,
        unlockRecord,
        handleLockedRecordError,
        getRecordError,
        watchLockedRecords,
    }
}